/** @jsxImportSource @emotion/react */

import FilterTimeTabs from "components/mobile/FilterTimeTabs";
import HeaderMobile from "components/mobile/HeaderMobile";
import TransactionTabs from "components/mobile/TransactionTabs";

import { TransactionsMobilePageStyle } from "./style.index";

const TransactionsMobilePage = () => {
  return (
    <>
      <HeaderMobile title="Lịch sử giao dịch tài khoản" />
      <div css={TransactionsMobilePageStyle.wrapper}>
        <FilterTimeTabs />
        <TransactionTabs />
      </div>
    </>
  );
};

export default TransactionsMobilePage;
